import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "./plugins/axios";
import { loadFonts } from "./plugins/webfontloader";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import VueApexCharts from "vue3-apexcharts";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import maska from "maska";
import 'primeicons/primeicons.css';                      // icons
import "./index.css";
import { VueReCaptcha } from 'vue-recaptcha-v3'

store.router = router;
store.axios = axios;

loadFonts();

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyCFBxXeI1Kl77cPxcROukfcj52Jgve2Azk",
      language: 'LO',
    },
  })
  .use(maska)
  .use(VueSweetalert2)
  .use(PrimeVue, {
      theme: {
          preset: Aura,
            options: {
              darkModeSelector: '',
          }
      }
  })
  .use(VueReCaptcha, { siteKey: '6LeqlTQqAAAAAKgVJvjAuR3x_Y6oP7rRrzO8paSq' })
  .component("Datepicker", Datepicker)
  .component("apexchart", VueApexCharts)
  .mount("#app");
